import { useRouter } from 'next/router';

const useRedirectToBookPage = (type: string, alias: string) => {
  const router = useRouter();

  if (type !== 'book') {
    typeof window !== 'undefined' && router.push(alias);
  }
};

export default useRedirectToBookPage;
